import {includes} from 'ramda';

import {
  GetMetadaServiceCaseApiResponse,
  GetServiceOrderVariantApiResponse,
} from '@dms/api/workshop';
import {useStateFlag} from '@dms/shared';

import {ServiceCaseOrder} from '../../../../../types/OrderType';
import {getSparePartStateFlag} from '../../../../../utils/getSparePartStateFlag';
import {getTimeTrackingStateFlag} from '../../../../../utils/getTimeTrackingStateFlag';
import {getMarkersFlags} from '../../../utils/getMarkersFlags';

interface UseOrderCardFlagsProps {
  serviceOrder: ServiceCaseOrder;
  canReadChronos: boolean;
  canEditServiceOrder: boolean;
  activeBranchId: string;
  serviceCase: GetMetadaServiceCaseApiResponse;
  serviceOrderVariant: GetServiceOrderVariantApiResponse;
}

export const useOrderCardFlags = (props: UseOrderCardFlagsProps) => {
  const orderState = props.serviceOrder?.state;
  const stateFlag = useStateFlag(orderState);
  const markersFlags = getMarkersFlags(props.serviceOrder?.markers);
  const timeTrackingFlag = props.canReadChronos
    ? getTimeTrackingStateFlag(props.serviceOrder?.timeTrackingState)
    : undefined;
  const sparePartFlag = getSparePartStateFlag(props.serviceOrder?.sparePartWarehouseState);

  const isOrderReadOnly =
    includes(props.serviceOrder?.state, ['LOCKED', 'ARCHIVED', 'CLOSED', 'CANCELLED']) ||
    !props.canEditServiceOrder;

  return {
    orderState,
    stateFlag,
    markersFlags,
    timeTrackingFlag,
    sparePartFlag,
    isOrderReadOnly,
  };
};
